import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import {
  LoginForm,
  SignupForm,
  ForgotPasswordForm,
  Slider,
} from './components';
import { NotificationContainer } from '../../layout/Main';
import authStore from '../../store/Auth';
import appStore from '../../store/App';
import { useAuth } from '../../contexts/AuthProvider';
import { LoginRequest, RegisterRequest } from '../../api/auth';

import s from './styles.module.scss';

const Login: React.FC = observer(() => {
  const [showSignup, setShowSignup] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const history = useHistory();
  const { isAuthenticated, isInitialized } = useAuth();

  useEffect(() => {
    // Если пользователь уже авторизован, перенаправляем на главную
    if (isInitialized && isAuthenticated) {
      history.push('/');
    }
  }, [isInitialized, isAuthenticated, history]);

  // Показываем лоадер пока идет инициализация
  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  // Если пользователь авторизован, не показываем страницу логина
  if (isAuthenticated) {
    return null;
  }

  const handleLogin = async (values: LoginRequest) => {
    try {
      await authStore.login(values);
      history.push('/');
    } catch (error: any) {
      console.error('Login error:', error);
      const errorMessage =
        error?.response?.data?.detail ||
        'Login failed. Please check your credentials and try again.';
      appStore.setNotification({
        type: 'error',
        title: errorMessage,
        width: 400,
      });
    }
  };

  const handleSignup = async (values: RegisterRequest) => {
    try {
      await authStore.register(values);
      setShowSignup(false);
      appStore.setNotification({
        type: 'success',
        title:
          'Registration successful! Please check your email to verify your account.',
        width: 500,
      });
    } catch (error: any) {
      console.error('Signup error:', error);
      const errorMessage =
        error?.response?.data?.detail ||
        'Registration failed. Please try again.';
      appStore.setNotification({
        type: 'error',
        title: errorMessage,
        width: 400,
      });
    }
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{
          padding: '0 70px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '452px' }}>
          {showForgotPassword ? (
            <ForgotPasswordForm onBack={() => setShowForgotPassword(false)} />
          ) : showSignup ? (
            <SignupForm
              loading={authStore.isLoading}
              onFinish={handleSignup}
              onLoginClick={() => setShowSignup(false)}
            />
          ) : (
            <LoginForm
              loading={authStore.isLoading}
              onFinish={handleLogin}
              onSignupClick={() => setShowSignup(true)}
              onForgotPasswordClick={() => setShowForgotPassword(true)}
            />
          )}
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
});

export default Login;
